import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import SimpleHeader from '../../ui-kit/SimpleHeader';
import { DICTIONARY } from '../../translations/dictionary';
import useTranslations from '../../hooks/useTranslations';
import PrivacyPolicyContent from '../../components/PrivacyPolicyContent';

function PrivacyPolicy() {
  const { t } = useTranslations();

  return (
    <div className={styles.privacy}>
      <div className={classNames('container')}>
        <div className={styles.privacyInner}>
          <SimpleHeader
            subtitle={t(DICTIONARY.privacySubTitle)}
            title={t(DICTIONARY.privacyTitle)}
            isCenter
          />
          <PrivacyPolicyContent />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
